module.exports = __webpack_public_path__ + "static/media/pinBg.878677c6.png";